var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0V8H24L16 0ZM14 8V0H3C1.34312 0 0 1.34312 0 3V29C0 30.6562 1.34312 32 3 32H21C22.6569 32 24 30.6569 24 29V10H16.0562C14.8937 10 14 9.10625 14 8ZM18.0063 21.5063C17.7688 21.8563 17.3875 22 17 22C16.6125 22 16.2325 21.8535 15.9394 21.5606L13.5 19.1187V25.5C13.5 26.3281 12.8281 27 12 27C11.1719 27 10.5 26.3281 10.5 25.5V19.1187L8.06063 21.5581C7.47469 22.1441 6.52562 22.1441 5.93937 21.5581C5.35313 20.9722 5.35344 20.0231 5.93937 19.4369L10.9394 14.4369C11.5253 13.8509 12.4744 13.8509 13.0606 14.4369L18.0606 19.4369C18.6437 20.025 18.6438 20.975 18.0063 21.5063Z",
    fill: "#6E916E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bfd52938bcd1642f8e82b3adcc8dbc1b.svg";
export { ForwardRef as ReactComponent };